import Home from "../views/Home.vue";
import StockIndexList from "@/views/stock-index-list.vue";
import StockIndexDetail from "@/views/stock-index-detail.vue";
import Index from "@/views/index.vue";
import Iframe from "@/views/iframe.vue";
import StockRanking from "@/views/stock-ranking.vue";
import MarketList from "@/views/market-list.vue";
import StockDetail from "@/views/stock-detail.vue";
import FuturesList from "@/views/futures-list.vue";
import FuturesDetail from "@/views/futures-detail.vue";
import MajorList from "@/views/major-list.vue";
import BondsList from "@/views/bonds-list.vue";
import EconomicIndicator from "@/views/economic-indicator.vue";
export default [
  {
    path: "/",
    name: "Home",
    component: Index,
    redirect: "/stock-index-list",
    children: [
      {
        path: "/stock-index-list",
        name: "list",
        component: StockIndexList,
        meta: {
          title: "股指条幅",
        },
      },

      {
        path: "/stock-ranking",
        name: "ranking",
        component: StockRanking,
        meta: {
          title: "个股排行",
        },
      },
      {
        path: "/futures-list",
        name: "FuturesList",
        component: FuturesList,
        meta: {
          title: "期货列表",
        },
      },
      {
        path: "/major-list",
        name: "MajorList",
        component: MajorList,
        meta: {
          title: "汇率列表",
        },
      },
      {
        path: "/bonds-list",
        name: "bondsList",
        component: BondsList,
        meta: {
          title: "国债列表",
        },
      },
      {
        path: "/economic-indicator",
        name: "economicIndicator",
        component: EconomicIndicator,
        meta: {
          title: "经济指标",
        },
      },
      {
        path: "/market-list",
        name: "market",
        component: MarketList,
        meta: {
          title: "股指列表",
        },
      },
    ],
  },
  {
    path: "/product/stock-index-list",
    name: "product_ranking",
    component: StockIndexList,
    meta: {
      title: "股指条幅",
    },
  },
  {
    path: "/product/stock-ranking",
    name: "product_ranking",
    component: StockRanking,
    meta: {
      title: "个股排行",
    },
  },
  {
    path: "/product/market-list",
    name: "market_list",
    component: MarketList,
    meta: {
      title: "股指列表",
    },
  },
  {
    path: "/product/stock-index-detail",
    name: "product_stock_detail",
    component: StockIndexDetail,
    meta: {
      title: "指数详情",
    },
  },
  {
    path: "/product/stock-detail",
    name: "StockDetail",
    component: StockDetail,
    meta: {
      title: "个股详情",
    },
  },
  {
    path: "/product/futures-detail",
    name: "FuturesDetail",
    component: FuturesDetail,
    meta: {
      title: "期货详情",
    },
  },
  {
    path: "/product/futures-list",
    name: "FuturesList",
    component: FuturesList,
    meta: {
      title: "期货列表",
    },
  },
  {
    path: "/product/bonds-list",
    name: "BondsList",
    component: BondsList,
    meta: {
      title: "国债列表",
    },
  },
  {
    path: "/product/economic-indicator",
    name: "EconomicIndicator",
    component: EconomicIndicator,
    meta: {
      title: "经济指标",
    },
  },
  {
    path: "/product/major-list",
    name: "MajorList",
    component: MajorList,
    meta: {
      title: "汇率列表",
    },
  },
  {
    path: "/iframe",
    name: "Home",
    component: Iframe,
  },
];
